import "./applicationDetailsStyles.scss";
import Content from "./content/Content";
import Header from "./header/Header";

const ApplicationDetails = () => {
  return (
    <section className="application-section" id="application">
      <Content />
    </section>
  );
};

export default ApplicationDetails;
